<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="预约信息"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="200px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto',minWidth: form_min_width,}" autocomplete="off">
            <el-form-item label="特属服务对象" prop="user_info">
                <el-autocomplete class="user_search"
                                 v-model="ruleForm.user_info"
                                 :fetch-suggestions="getUser"
                                 placeholder="请输入内容"
                                 @select="userSelect"
                                 @blur="resetUserInfo"
                ></el-autocomplete>
            </el-form-item>
            <el-form-item label="特属服务对象联系电话" prop="user_mobile">
                <el-input type="text" v-model="user_mobile" placeholder="请输入特属服务对象联系电话" autocomplete="off"
                          style="width: 100%;" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="联系人" prop="contact_id">
                <el-select v-model="ruleForm.contact_id" filterable @change="changeContact" placeholder="请选择联系人"
                           style="width: 100%;">
                    <el-option
                        v-for="item in allAssistant"
                        :key="item.user_id"
                        :label="item.user_name"
                        :value="item.user_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="联系人联系电话">
                <el-input type="text" v-model="ruleForm.contact_mobile" placeholder="请输入联系人联系电话" autocomplete="off"
                          style="width: 100%;" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="特属专家" prop="doctor_id">
                <el-select class="doctor" v-model="ruleForm.doctor_id" @change="changeDoctor" filterable placeholder="请选择特属专家" style="width: 100%;" v-if="user_role == 2">
                    <el-option
                        v-for="item in allDoctor"
                        :key="item.user_id"
                        :label="item.doctor_name"
                        :value="item.user_id"
                    ></el-option>
                </el-select>
                <el-select v-model="ruleForm.doctor_id" @change="changeDoctor" filterable placeholder="请选择特属专家" style="width: 100%;" v-if="user_role != 2">
                    <el-option
                        v-for="item in allDoctor"
                        :key="item.user_id"
                        :label="item.doctor_name"
                        :value="item.user_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="特属专家联系电话">
                <el-input type="text" v-model="doctor_mobile" placeholder="请输入特属专家联系电话" autocomplete="off"
                          style="width: 100%;" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status" @change="statusChange">
                    <el-radio :label="1">预约处理</el-radio>
                    <el-radio :label="2" disabled>等待会面</el-radio>
                    <el-radio :label="3" disabled>会面完成</el-radio>
                    <el-radio :label="4" disabled>会面中断</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="会面中断原因" v-if="is_interrupt">
                <el-input type="textarea"  id="remark" v-model="ruleForm.remark" placeholder="请输入会面取消原因（30字内）" autosize maxlength="30" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="特属服务专员" prop="input_user_id">
                <el-select class="manager" v-model="ruleForm.input_user_id" placeholder="请选择特属服务专员" :disabled="true" style="width: 100%;" v-if="user_role == 2">
                    <el-option
                        v-for="item in allManager"
                        :key="item.user_id"
                        :label="item.user_name"
                        :value="item.user_id"
                    ></el-option>
                </el-select>
                <el-select v-model="ruleForm.input_user_id" placeholder="请选择特属服务专员" style="width: 100%;" v-if="user_role != 2">
                    <el-option
                        v-for="item in allManager"
                        :key="item.user_id"
                        :label="item.user_name"
                        :value="item.user_id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="会面地点" prop="address" v-if="ruleForm.status == 2">
                <el-select v-model="ruleForm.address_id" placeholder="请选择特属服务专员" style="width: 100%;">
                    <el-option
                        v-for="item in doctorAddress"
                        :key="item.id"
                        :label="item.address_info"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="期望会面时间" prop="book_date" v-if="ruleForm.doctor_id">
                <span class="el-input is-disabled .el-input__inner" @click="getDoctorVisit" style="width: 100%;border-radius: 4px;
    border: 1px solid #DCDFE6;
    box-sizing: border-box;outline: 0;
    padding: 0 15px;background-color: #FFF;
    text-align: left;height: 32px;line-height: 32px;cursor:pointer;">{{ruleForm.book_date}}</span>
<!--                <el-input type="text" v-model="ruleForm.book_date" placeholder="期望会面时间" autocomplete="off"-->
<!--                          style="width: 100%;" :disabled="true" @click="getDoctorVisit"></el-input>-->
            </el-form-item>
            <el-form-item prop="half"  v-if="ruleForm.doctor_id">
                <el-radio-group v-model="ruleForm.half" :disabled="true">
                    <el-radio :label="1">上午</el-radio>
                    <el-radio :label="2">下午</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="会面日期" prop="meet_date" v-if="ruleForm.status == 2">
                <el-date-picker
                    v-model="ruleForm.meet_date"
                    type="date"
                    placeholder="选择日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="会面时间" prop="meet_time" v-if="ruleForm.status == 2">
                <el-select v-model="ruleForm.meet_time" filterable placeholder="请选择会面时间"
                           style="width: 100%;">
                    <el-option
                        v-for="item in time_frame"
                        :key="item.id"
                        :label="item.name"
                        :value="item.name"
                    ></el-option>
                </el-select>
            </el-form-item>
            <!-- form表单提交 -->
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>

        <el-dialog :title="dialog_visit" :visible.sync="visitFormVisible" @close="visitClose">
            <el-form label-position="right" :model="ruleForm" ref="visitForm" label-width="90px"
                     class="form"
                     style="width: 80%;margin: 20px auto 0 auto;" autocomplete="off">
                <el-form-item label="排班地址" prop="address_id">
                    <el-select v-model="ruleForm.address_id"
                               placeholder="请选择排班地址"
                               @change="addressChange"
                               style="width: 100%;">
                        <el-option
                            v-for="item in doctorAddress"
                            :key="item.id"
                            :label="item.address_info"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="排班时间表">
                    <el-carousel indicator-position="outside" arrow="never"
                                 :autoplay="false" height="180px" @change="visitCarouselChange"
                                 trigger="click"
                                 ref="visitCarousel"
                                 :initial-index="activeIndex"
                    >
                        <el-carousel-item v-for="date_arr in visit_date_arr">
                            <div class="visit_time_container">
                                <div class="visit_time_box" v-for="(dat, i) in date_arr"
                                     :data-date="dat.date_val"
                                     :data-id="dat.id"
                                     :data-half="dat.half">
                                    <!-- 周一到周五 -->
                                    <div :class="dat.header_class" >
                                        <div>
                                            <p>{{ dat.week }}</p>
                                            <p>{{ dat.date }}</p>
                                        </div>
                                    </div>
                                    <div :class="dat.am_class" @click="halfSelect($event)" v-if="dat.is_am_can_select && dat.am_class.indexOf('history') < 0">
                                        <div v-if="dat.am_class.indexOf('history') < 0 || dat.am_class.indexOf('weekend') > -1">上午</div>
                                        <div v-else>&nbsp;</div>
                                    </div>
                                    <div :class="dat.am_class" v-else>
                                        <div v-if="dat.am_class.indexOf('history') < 0 || dat.am_class.indexOf('weekend') > -1">上午</div>
                                        <div v-else>&nbsp;</div>
                                    </div>
                                    <div :class="dat.pm_class" @click="halfSelect($event)" v-if="dat.is_pm_can_select && dat.pm_class.indexOf('history') < 0">
                                        <div v-if="dat.pm_class.indexOf('history') < 0 || dat.pm_class.indexOf('weekend') > -1">下午</div>
                                        <div v-else>&nbsp;</div>
                                    </div>
                                    <div :class="dat.pm_class" v-else>
                                        <div v-if="dat.pm_class.indexOf('history') < 0 || dat.pm_class.indexOf('weekend') > -1">下午</div>
                                        <div v-else>&nbsp;</div>
                                    </div>

                                </div>
                            </div>

                        </el-carousel-item>
                    </el-carousel>

                </el-form-item>
            </el-form>

        </el-dialog>
    </div>
</template>
<script>
import env from "@/api/env";
import {getUserInfos} from '@/utils/userInfos';
import {check} from "@/utils/checkData";
import {getFormatDate} from "@/utils/date";
import {isMobile} from "@/api/order";

export default {
    created() {
        localStorage.setItem('prev_page', 'work_add')
        let userData = getUserInfos();
        this.ruleForm.input_user_name = userData.user_name;
        this.user_role = userData.role_id
        this.role_user_id = userData.user_id
        if (isMobile()) {
            this.form_min_width = "none"
            this.form_width = "100%"
        }
    },
    mounted() {
        this.getAddEditParams();
    },
    data() {
        return {
            user_role: 0,
            role_user_id: '',
            search_key: '',// 特属服务对象输入临时存储
            allUser: [],
            allAssistant: [],
            allDoctor: [],
            allManager: [],
            doctorAddress: [],
            reservation_id: '',
            input_user_name: '',
            user_mobile: '',
            old_user_name: '',// 已选择的用户名
            doctor_mobile: '',
            is_interrupt: false,
            time_frame: [
                {id: 1, name: "8:00~9:00"},
                {id: 2, name: "9:00~10:00"},
                {id: 3, name: "10:00~11:00"},
                {id: 4, name: "11:00~12:00"},
                {id: 5, name: "12:00~13:00"},
                {id: 6, name: "13:00~14:00"},
                {id: 7, name: "14:00~15:00"},
                {id: 8, name: "15:00~16:00"},
                {id: 9, name: "16:00~17:00"},
                {id: 10, name: "17:00~18:00"},
            ],
            ruleForm: {
                user_info: '',
                user_id: "",
                doctor_id: "",
                contact_id: "",
                contact_name: "",
                contact_mobile: "",
                book_date: "请选择期望会面时间",
                half: 0,
                status: 1,
                remark: "",
                input_user_id: '',
                address_id: "",
                meet_date: "",
                meet_time: "",
            },
            rules: {
                user_id: [
                    {required: true, message: "请选择特属服务对象", trigger: "blur"},
                ],
                user_info: [
                    {required: true, message: "请选择特属服务对象", trigger: "blur"},
                ],
                contact_id: [
                    {required: true, message: "请选择联系人", trigger: "blur"},
                ],
                doctor_id: [
                    {required: true, message: "请选择特属专家", trigger: "blur"},
                ],
                status: [
                    {required: true, message: "请选择状态", trigger: "blur"},
                ],
                book_date: [
                    {required: true, message: "请选择期望会面时间", trigger: "blur"},
                ],
                half: [
                    {required: true, message: "请选择上午或下午", trigger: "blur"},
                ],
                input_user_id: [
                    {required: true, message: "请选择特属服务专员", trigger: "blur"},
                ],
                address: [
                    {required: true, message: "请选择会面地址", trigger: "blur"},
                ],
                meet_date: [
                    {required: true, message: "请选择会面日期", trigger: "blur"},
                ],
                meet_time: [
                    {required: true, message: "请选择会面时间", trigger: "blur"},
                ],
            }, pickerOptions: {
                disabledDate: (time) => {
                    return time.getTime() < Date.now() - 8.64e7;  // 当天之前不可选
                }
            },
            doctor_name:'',
            is_submit: false,
            dialog_visit: "专家排班",
            visitFormVisible: false,
            isShowVisitData: 1,
            is_edit: false,
            is_more: true,
            visit_page: 1,
            last_date: '2023-02-06',
            activeIndex: 0,
            // 日期表
            visit_date_arr: [],
            // 已排班日期
            visit_date_res: [
                [
                    {date:"02/06", half: "selected", id: 0},
                    {date:"02/07", half: "selected", id: 0},
                    {date:"02/08", half: "selected", id: 0},
                    {date:"02/09", half: "selected", id: 0},
                    {date:"02/10", half: "selected", id: 0},
                    {date:"02/11", half: "", id: 0},
                    {date:"02/12", half: "", id: 0},
                ],

            ],
            form_width: "40%",
            form_min_width: "640px"
        };
    },
    methods: {
        // 所有特属服务对象，特属专家
        getAddEditParams() {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'addEditParams',
                params: {
                    reservation_id: this.reservation_id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allUser = res.data.data.user;
                this.allDoctor = res.data.data.doctor;
            });
        },

        // 获取子账户
        getAssistant() {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'getAssistant',
                params: {
                    user_id: this.ruleForm.user_id
                }
            };

            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }

                this.allAssistant = res.data.data.assistantList;
                this.allDoctor = res.data.data.doctorList;
                for (let i = 0; i < res.data.data.assistantList.length; i++) {
                    if (res.data.data.assistantList[i].is_main == 1  || res.data.data.assistantList.length == 1) {
                        this.ruleForm.contact_id = res.data.data.assistantList[i].user_id
                        this.changeContact()
                        break;
                    }
                }
                if (res.data.data.doctorList.length == 1) {
                    this.ruleForm.doctor_id = res.data.data.doctorList[0].user_id
                    this.changeDoctor()
                }
            });
        },

        // 返回上一页
        goBack() {
            window.history.go(-1);
            return false;
        },
        statusChange(v) {
            if (v == 4) {
                this.is_interrupt = true
                var timer = setInterval(function () {
                    let remark = document.getElementById("remark")
                    remark.focus()
                    clearTimeout(timer)
                },100)
            } else {
                this.is_interrupt = false
            }
        },
        // 提交表单
        submitForm(formName) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let _that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        'servername': 'Ruyi_AdminWorkbenchServices',
                        'method': 'createReservation',
                        'params': {
                            reservation_id: this.reservation_id,
                            user_id: this.ruleForm.user_id,
                            doctor_id: this.ruleForm.doctor_id,
                            contact_id: this.ruleForm.contact_id,
                            book_date: this.ruleForm.book_date,
                            half: this.ruleForm.half == 1 ? '上午' : '下午',
                            status: this.ruleForm.status,
                            remark: this.ruleForm.remark,
                            input_user_id: this.ruleForm.input_user_id,
                            address_id: this.ruleForm.address_id,
                            meet_date: this.ruleForm.meet_date,
                            meet_time: this.ruleForm.meet_time,
                        }
                    };
                    this.$api.service(params).then(res => {
                        if (!check(res)) {
                            this.is_submit = false;
                            return;
                        }
                        this.$message({
                            type: "success",
                            message: '创建成功',
                            duration: 1500,
                            onClose: function () {
                                _that.is_submit = false;
                                window.history.go(-1);
                                return;
                            }
                        });
                    }).catch(()=>{
                        this.is_submit = false;
                    }).finally(() => {
                        this.is_submit = false;
                    });
                } else {
                    this.$message({
                        type: "error",
                        message: '请输入必填项'
                    });
                    this.is_submit = false;
                    return false;
                }
            });
        },

        // 选择用户
        changeUser() {
            let allUser = this.allUser;
            let user_id = this.ruleForm.user_id;

            let mobile;
            for (let i = 0; i < allUser.length; i++) {

                if (allUser[i].user_id == user_id) {
                    mobile = allUser[i].mobile;
                }
            }
            this.user_mobile = mobile;

            this.ruleForm.contact_id = null;
            this.ruleForm.contact_mobile = null;
            this.ruleForm.doctor_id = null;
            this.ruleForm.doctor_mobile = null;
            this.doctor_mobile = '';
            this.ruleForm.input_user_id = '';
            // 获取子账户
            this.getAssistant();
        },

        // 选择医生
        changeDoctor() {
            let allDoctor = this.allDoctor;
            let doctor_id = this.ruleForm.doctor_id;
            let mobile;
            for (var i = 0; i < allDoctor.length; i++) {
                if (allDoctor[i].user_id == doctor_id) {
                    mobile = allDoctor[i].mobile;
                }
            }
            this.doctor_mobile = mobile;

            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'getManager',
                params: {
                    doctor_id: this.ruleForm.doctor_id
                }
            };

            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }

                this.allManager = res.data.data.managerList;
                this.doctorAddress = res.data.data.addressList;
                for (let i = 0; i < res.data.data.managerList.length; i++) {
                    if (res.data.data.managerList.length == 1 || this.role_user_id == res.data.data.managerList[i].user_id) {
                        this.ruleForm.input_user_id = res.data.data.managerList[i].user_id
                    }
                }
            });
        },

        // 选择子账户
        changeContact() {
            let allAssistant = this.allAssistant;
            let contact_id = this.ruleForm.contact_id;
            let mobile;
            for (var i = 0; i < allAssistant.length; i++) {
                if (allAssistant[i].user_id == contact_id) {
                    mobile = allAssistant[i].mobile;
                }
            }
            this.ruleForm.contact_mobile = mobile;
        },

        // 特属服务对象搜索
        getUser(key, cb) {
            if (key.indexOf('/') > -1) {
                this.prev_search = key.split('/')[1] || key.split('/')[0]
                key = this.prev_search
            }

            if (!key) {
                this.search_key = '';
                cb([{"value": "请输入特属服务对象关键词"}]);
                return;
            }
            this.search_key = key
            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'searchUser',
                params: {
                    user_name: key,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                    return;
                }
                var users = res.data.data
                if (!users) {
                    return cb([{"value": "没有找到特属服务对象"}]);
                }
                for (var i = 0; i < users.length; i++) {
                    users[i].value = users[i].short_name + '/' + users[i].user_name
                }
                cb(users);
            });

        },
        userSelect(item) {
            this.ruleForm.user_id = item.user_id;
            this.ruleForm.user_name = item.user_name;
            this.old_user_name = ''
            this.old_user_name = this.ruleForm.user_info
            this.changeUser()
        },
        resetUserInfo() {
            if (this.ruleForm.user_id) {
                this.ruleForm.user_info = this.old_user_name
            }

        },
        // 查看专家排班
        async getDoctorVisit() {
            this.last_date = getFormatDate('Y-m-d', ((new Date()).getTime() - 86400 * 1000)/1000)

            this.visitFormVisible = true;
            this.is_edit = false;
            this.is_more = true;

            await this.getDoctorAddress()
        },
        async addressChange() {

            this.visit_page = 1;
            this.visit_date_arr = [];
            this.visit_date_res = [];

            let nowTime = new Date(); //当前的时间戳 毫秒
            let nowDay = nowTime.getDay(); // 当前是星期几
            let day = (nowDay > 0) ? nowDay : 7;
            let MonDayTime = nowTime - (day - 1) * 86400 * 1000; // 周一的时间戳 毫秒

            setTimeout(()=>{
                this.getVisitList()
                setTimeout(()=>{
                    this.getVisitArr(MonDayTime)
                }, 1000)
            },50)


        },
        getDoctorAddress() {
            let params = {
                servername: 'Ruyi_AdminWorkbenchServices',
                method: 'getAddress',
                params: {
                    doctor_id: this.ruleForm.doctor_id
                }
            };
            this.doctorAddress = [];
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data) {
                    this.doctorAddress = res.data.data;
                    for (let i = 0; i < this.doctorAddress.length; i++) {
                        if (this.doctorAddress[i].is_default == 1) {
                            this.ruleForm.address_id = this.doctorAddress[i].id;
                            this.addressChange()
                        }
                    }
                }
            });
        },
        visitClose() {
            this.visitFormVisible = false;
            this.is_edit = false;
            this.is_more = true;
            this.visit_page = 1;
            this.visit_date_arr = [];
            this.visit_date_res = [];
            this.doctorAddress = [];
            getFormatDate('Y-m-d', ((new Date()).getTime() - 86400 * 1000)/1000)
        },
        // 日期排班选项卡切换
        async visitCarouselChange() {
            let visit_date_arr_len = this.visit_date_arr.length
            let time = 0;
            let _that = this
            let activeIndex = this.$refs.visitCarousel.activeIndex;
            this.activeIndex = activeIndex
            if ((activeIndex + 1) == visit_date_arr_len) {
                // 切换到最后一个
                if (this.is_more) {
                    // 加载更多排班
                    this.visit_page += 1;
                    await this.getVisitList()
                    setTimeout(function () {
                        if (visit_date_arr_len < 1) {
                            let nowTime = new Date(); //当前的时间戳 毫秒
                            let nowDay = nowTime.getDay(); // 当前是星期几
                            let day = (nowDay > 0) ? nowDay : 7;
                            time = nowTime - (day - 1) * 86400 * 1000; // 周一的时间戳 毫秒
                        } else {
                            time = ((new Date(_that.visit_date_arr[visit_date_arr_len - 1][6].date_val)).getTime()) + 86401*1000
                        }
                        _that.getVisitArr(time)
                    }, 500)
                }
            }
            return;

        },
        // 从后台获取排班数据
        getVisitList() {
            let params = {
                servername: 'Ruyi_AdminExpertServices',
                method: 'getDoctorVisits',
                pageinfo: {
                    page: this.visit_page,
                },
                params: {
                    doctor_id: this.ruleForm.doctor_id,
                    address_id: this.ruleForm.address_id
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data) {
                    let dat = res.data.data
                    for (var i = 0; i < dat.length; i++) {
                        this.visit_date_res.push({
                            date: dat[i].visit_date,
                            half: dat[i].half,
                            id: dat[i].id,
                        })
                    }

                    this.last_date = dat[dat.length - 1].visit_date
                } else {
                    this.is_more = false;
                }


            }).catch((e) => {
                // console.log(e)
            });
        },
        getVisitArr(MonDayTime) {
            let nowTime = new Date(); //当前的时间戳 毫秒

            let arr = [];
            let time = 0;
            let select = '';
            let history = false;
            let res_arr = this.visit_date_res; // 排班时间
            let header_class = ''; // 日期class
            let am_class = ''; // 上午class
            let pm_class = ''; // 下午class
            let half = ''; // 新排班值
            let old_half = ''; // 旧排班值
            let id = 0; // id值
            let after_page = 0;
            let res_end = false;
            let is_am_can_select = false;
            let is_pm_can_select = false;
            for (let i = 0; i < 4*7; i++) {
                history = false;
                time = MonDayTime + i * 86400 * 1000;
                if (i % 7 < 5) {
                    select = "selected";
                }
                if (time < (new Date(getFormatDate('Y-m-d', (nowTime.getTime())/1000))).getTime()) {
                    history = true;
                }

                if ((new Date(getFormatDate("Y-m-d", time/1000))).getTime() <= (new Date(this.last_date)).getTime()) {
                    // 排班表内时间
                    for (let j = 0; j < res_arr.length; j++) {
                        if (getFormatDate("Y-m-d", time/1000) == res_arr[j].date) {
                            id = res_arr[j].id
                            if (res_arr[j].date == getFormatDate("Y-m-d", nowTime/1000)
                                && getFormatDate("H", nowTime/1000) >= 17) {
                                // 今天的排班 过了下午5点
                                header_class = "visit_time time_header history";
                            } else {
                                header_class = "visit_time time_header selected";
                            }
                            // 这一天有排班
                            switch (res_arr[j].half) {
                                case '全天':
                                    old_half = '全天';
                                    half = '全天';

                                    if (res_arr[j].date == getFormatDate("Y-m-d", nowTime/1000)
                                        && getFormatDate("H", nowTime/1000) >= 17) {
                                        // 今天的排班 过了下午5点
                                        is_am_can_select = false;
                                        is_pm_can_select = false;
                                        header_class = "visit_time time_header history";
                                        am_class = "visit_time time_am history";
                                        pm_class = "visit_time time_pm history";
                                    } else if (res_arr[j].date == getFormatDate("Y-m-d", nowTime/1000)
                                        && getFormatDate("H", nowTime/1000) >= 11){
                                        is_am_can_select = false;
                                        is_pm_can_select = true;
                                        am_class = "visit_time time_am history";
                                        pm_class = "visit_time time_pm selected";
                                    } else {
                                        is_am_can_select = true;
                                        is_pm_can_select = true;
                                        am_class = "visit_time time_am selected";
                                        pm_class = "visit_time time_pm selected";
                                    }


                                    break;
                                case "上午":
                                    old_half = '上午';
                                    half = '上午';
                                    if (res_arr[j].date == getFormatDate("Y-m-d", nowTime/1000)
                                        && getFormatDate("H", nowTime/1000) >= 11) {
                                        header_class = "visit_time time_header history";
                                        am_class = "visit_time time_am history";
                                        is_am_can_select = false;
                                    } else {
                                        am_class = "visit_time time_am selected";
                                        is_am_can_select = true;
                                    }
                                    if (i % 7 >= 5) {
                                        pm_class = "visit_time time_pm history weekend";
                                    } else {
                                        pm_class = "visit_time time_pm history";
                                    }

                                    is_pm_can_select = false;
                                    break;
                                case "下午":
                                    old_half = '下午';
                                    half = '下午';
                                    if (i % 7 >= 5) {
                                        am_class = "visit_time time_am history weekend";
                                    } else {
                                        am_class = "visit_time time_am history";
                                    }
                                    if (res_arr[j].date == getFormatDate("Y-m-d", nowTime/1000)
                                        && getFormatDate("H", nowTime/1000) >= 17) {
                                        header_class = "visit_time time_header history";
                                        pm_class = "visit_time time_pm history";
                                        is_pm_can_select = false;
                                    } else {
                                        pm_class = "visit_time time_pm selected";
                                        is_pm_can_select = true;
                                    }

                                    is_am_can_select = false;
                                    break;
                            }
                            break;
                        } else {
                            if (i % 7 < 5 && after_page > 0) {
                                header_class = "visit_time time_header selected";
                                am_class = "visit_time time_am selected";
                                pm_class = "visit_time time_pm selected";
                            } else {
                                header_class = "visit_time time_header";
                                am_class = "visit_time time_am history weekend";
                                pm_class = "visit_time time_pm history weekend";
                            }
                        }
                    }
                } else {
                    res_end = true;
                    // 排班表之后的时间
                    if (this.is_edit) {
                        //
                        // if (
                        //     (after_page > 0
                        //         || time > ((new Date(this.last_date)).getTime()) + 86400*1000*7
                        //         || (new Date(this.last_date)).getTime() < (new Date().getTime()))
                        //     && (i % 7 < 5)
                        // ) {
                        //     header_class = `visit_time time_header selected`;
                        //     am_class = `visit_time time_am selected`;
                        //     pm_class = `visit_time time_pm selected`;
                        // } else {
                        //     header_class = `visit_time time_header`;
                        //     am_class = `visit_time time_am`;
                        //     pm_class = `visit_time time_pm`;
                        // }
                        // if (this.visit_date_arr.length == 0 && ((new Date(this.last_date)).getTime()) < (new Date()).getTime() && (i % 7 < 5)) {
                        //     half = '全天';
                        // }
                    } else {
                        after_page = 1;
                        header_class = `visit_time time_header`;
                        am_class = `visit_time time_am`;
                        pm_class = `visit_time time_pm`;
                    }

                }

                if (this.is_edit) {
                    header_class = `${header_class} edit`;
                    am_class = `${am_class} edit`;
                    pm_class = `${pm_class} edit`;

                }
                if (history) {
                    header_class = `visit_time time_header history`;
                    am_class = `visit_time time_am history`;
                    pm_class = `visit_time time_pm history`;
                }
                arr.push({
                    date:getFormatDate("m/d", time/1000),
                    date_val:getFormatDate("Y-m-d", time/1000),
                    week: this.getWeek(time),
                    sel: select,
                    history: history,
                    old_half: old_half,
                    half: half,
                    id: id,
                    header_class: header_class,
                    am_class: am_class,
                    pm_class: pm_class,
                    is_am_can_select: is_am_can_select,
                    is_pm_can_select: is_pm_can_select,
                })
                id = '';
                am_class = '';
                pm_class = '';
                old_half = '';
                half = '';
                select = '';

                if ((i + 1)% 7 == 0) {
                    this.visit_date_arr.push(arr)
                    arr = [];
                    if (after_page == 1 && !this.is_edit) {
                        after_page = 0;
                        break;
                    }
                    if (res_end) {
                        after_page += 1;
                    }
                }

            }

        },
        getWeek(date) {
            let day = (new Date(date)).getDay();
            let week = '';
            switch (day) {
                case 0:
                    week = '周日';
                    break;
                case 1:
                    week = '周一';
                    break;
                case 2:
                    week = '周二';
                    break;
                case 3:
                    week = '周三';
                    break;
                case 4:
                    week = '周四';
                    break;
                case 5:
                    week = '周五';
                    break;
                case 6:
                    week = '周六';
                    break;
                default:
                    break;
            }
            return week;
        },
        // 选择上下午
        halfSelect(obj) {
            obj.preventDefault();
            let parent_node = obj.currentTarget.parentNode;
            let class_str = obj.currentTarget.className

            this.ruleForm.book_date = parent_node.getAttribute('data-date');
            this.ruleForm.half = class_str.indexOf('time_am') > 0 ? 1 : 2;
            this.visitFormVisible = false;
        },
    }

};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 316px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 316px;
    height: 200px;
    display: block;
}

.editor {
    line-height: normal !important;
    height: 800px;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
    content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: '保存';
    padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
    content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
    content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
    content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
    content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
    content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
    content: '等宽字体';
}

.user_search {
    text-align: left;
    width: 100%;
}
.el-select.manager {
    .el-icon-arrow-up {
        color: #f5f7fa;
    }
}
.el-select.doctor {
    .el-icon-arrow-up {
        color: #fff;
    }
}
.el-carousel__indicators--outside button{
    background: #006aff;
}
.el-carousel__button{
    height: 5px;
}
.visit_time_container {
    display: flex;flex-direction: row;
    padding: 20px 20px;
    width: 100%;box-sizing: border-box;
    .visit_time_box {
        width: 13%;margin-right: 1.5%;
        box-sizing: border-box;font-size: 14px;
        .visit_time {
            cursor: default;
            border-radius:5px;
            background: #e9e9e9;
            &.time_am{
                margin-top: 10px;
                &.selected {
                    background: #ccedfc;
                    color: #02a7f0;
                }
            }
            &.time_pm{
                margin-top: 5px;
                &.selected {
                    background: #ccedfc;
                    color: #02a7f0;
                }
            }
            &.selected {
                background: #02a7f0;
                color: #fff;
                cursor: pointer;
            }
            &.time_header{
                p{
                    height: 1em;
                    line-height: 1em;
                    margin-top: 0;
                    margin-bottom: 0;
                    &:first-child{
                        padding-top:7px;padding-bottom: 0;
                    }
                    &:last-child{
                        padding-top: 0;padding-bottom: 7px;
                    }
                }
            }
            &.history {
                cursor: not-allowed;
            }

        }
        &:nth-child(7n+7){
            margin-right: 0;
        }
    }
}
</style>
